<template>
  <div class="bg-card">
    <h3 class="text-center mb-3">
      {{ $t('pages.one-offer.sidebar.share-offer.title', 'Share this offer') }}
    </h3>
    <SocialSharing
      :url="url"
      :title="title"
      :description="description"
      :quote="quote"
    />
    <Courses />
  </div>
</template>

<script>
import SocialSharing from '@/components/jobs/shared/SocialSharing.vue';
import Courses from '@/components/jobs/infoSidebar/blocks/Courses';

export default {
  components: {
    SocialSharing,
    Courses
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    quote: {
      type: String,
      default: ""
    },
  }
}
</script>
